import styled from '@emotion/styled'
import { Editable } from 'slate-react'

const StyledRichTextEditorContainer = styled.div`
  width: 100%;
  border-radius: 4px;
  border: 1px solid #dbdfea;
`
const StyledRichTextEditor = styled(Editable)`
  padding: 12px;
  background: var(--ow-color-white-100);
  min-height: auto;
  height: 300px;
  overflow-y: auto;
  ul,
  ol {
    padding-left: 40px;
    margin: 16px 0;
  }
  ul {
    list-style: decimal;
  }
  ol {
    list-style: disc;
  }
  h2 {
    font-size: 24px;
    font-weight: var(--font-weight-black);
  }
  h1 {
    font-size: 32px;
    font-weight: var(--font-weight-extrablack);
  }
  blockquote {
    border-left: 2px solid #ddd;
    margin-left: 0;
    margin-right: 0;
    padding-left: 10px;
    color: #aaa;
    font-style: italic;
  }
`
const StyledRichTextToolbar = styled.div`
  position: relative;
  padding: 5px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--ow-color-neutral-300);
  background: var(--ow-color-white-100);
  > span + span {
    margin-left: 15px;
  }
`

const StyledRichLineHeight = styled.div`
  top: 30px;
  left: 0;
  z-index: 1;
  background: var(--ow-color-white-100);
  width: 128px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.1),
    0 8px 10px 1px rgba(0, 0, 0, 0.06), 0 3px 14px 2px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  padding: 8px;
  > div {
    padding: 8px;
    font-size: var(--font-size-sm);
    color: var(--ow-color-gray-100);
    &:hover {
      background: var(--ow-color-neutral-100);
    }
  }
`

export {
  StyledRichTextEditorContainer,
  StyledRichTextEditor,
  StyledRichTextToolbar,
  StyledRichLineHeight,
}
